const possibleTypes = {
  Roleable: ["Admin", "Clerk", "Patient", "Practitioner"],
  Uploadable: ["Document", "ImatContent"],
};

export { possibleTypes };
